import React from 'react'
import PropTypes from 'prop-types'
import { sendHoverSoundCommand, sendClickSoundCommand } from 'react-wot-bootstrap'
import { push } from 'react-router-redux'
import { useDispatch } from 'react-redux'

import { CLAN_LEAVING } from 'urls'

import styles from './ButtonLeavingClan.scss'

const ButtonLeavingClan = ({ tooltipId }) => {
    const dispatch = useDispatch()

    const dataAttrs = tooltipId ? { 'data-tip': true, 'data-for': tooltipId } : {}

    return (
        <button
            className={styles.base}
            onClick={e => {
                e.stopPropagation()
                dispatch(push(CLAN_LEAVING))
            }}
            onMouseDown={sendClickSoundCommand}
            onMouseEnter={sendHoverSoundCommand}
            {...dataAttrs}
        />
    )
}

ButtonLeavingClan.propTypes = {
    tooltipId: PropTypes.string,
}

export default ButtonLeavingClan



// WEBPACK FOOTER //
// ./components/ButtonLeavingClan/ButtonLeavingClan.jsx